
import { defineComponent, computed, ref } from "vue";
export default defineComponent({
  name: "CookiesPopup",
  setup() {
    const isModalShow = ref(true);
    const cookiesAccepted = computed({
      get: () => !!localStorage.getItem("cookiesAccepted"),
      set: (x) => {
        localStorage.setItem("cookiesAccepted", x.toString());
      },
    });

    const handleAcceptCookies = () => {
      cookiesAccepted.value = true;
      isModalShow.value = false;
    };

    return { cookiesAccepted, handleAcceptCookies, isModalShow };
  },
});
